import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f17da61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "menu-header-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "ion-padding" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("by Räder-123 GmbH")
const _hoisted_6 = { class: "menu-button-container ion-padding-horizontal" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Demo Slides")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Meine Scans")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("App Installieren")
const _hoisted_10 = { class: "version-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_SettingsComponent = _resolveComponent("SettingsComponent")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_split_pane = _resolveComponent("ion-split-pane")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_split_pane, { "content-id": "main-content" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_menu, {
            "content-id": "main-content",
            type: "overlay",
            swipeGesture: "false"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("img", {
                        src: _ctx.isDark ? 'assets/img/logo_dark.png' : 'assets/img/logo_light.png',
                        alt: "Logo",
                        class: "image"
                      }, null, 8, _hoisted_3),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_ion_text, {
                          color: _ctx.notLiveStage ? 'warning' : 'dark'
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h1", null, "Detection X " + _toDisplayString(_ctx.notLiveStage ? '- Test': ''), 1)
                          ]),
                          _: 1
                        }, 8, ["color"]),
                        _createVNode(_component_ion_note, null, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_ion_list, { lines: "full" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              button: "",
                              "router-link": "/demoSlides",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menuController.close()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { color: "primary" }, {
                                  default: _withCtx(() => [
                                    _hoisted_7
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, {
                              button: "",
                              "router-link": "/scans",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.menuController.close()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { color: "primary" }, {
                                  default: _withCtx(() => [
                                    _hoisted_8
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", null, [
                        (_ctx.showInstall)
                          ? (_openBlock(), _createBlock(_component_ion_list, {
                              key: 0,
                              lines: "none"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  button: "",
                                  onClick: _ctx.install
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { color: "primary" }, {
                                      default: _withCtx(() => [
                                        _hoisted_9
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_ion_note, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Version " + _toDisplayString(_ctx.version), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_button, {
                              id: "open-modal",
                              fill: "clear"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: _ctx.settings
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_component_SettingsComponent)
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_router_outlet, { id: "main-content" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}